__webpack_require__.hmrF = () => ("core." + __webpack_require__.h() + ".hot-update.json");